
  import ScreenSize from '@/mixins/ScreenSize';
  export default {
    components: {
      RichText: () => import('@/components/elements/RichText'),
      RegistrationOrLoginDialog: () =>
        import('@/components/candidate/RegistrationOrLoginDialog'),
      LoginAndRegistrationDialog: () =>
        import('@/components/organization/LoginAndRegistrationDialog'),
    },
    mixins: [ScreenSize],
    props: {
      element: {
        type: Object,
        required: true,
      },
    },
  };
